<template>
	<div class="footer">
		<div class="row__spacebetween">
			<a class="logo--svg" href="https://www.connect-pb.de/">
				<FooterLogo />
			</a>
			<div class="row_end ml-auto">
				<a
					href="https://connect-pb.de/kontakt/"
					class="footer__link"
					><p class="text__grey">Kontakt</p></a
				>
				<a
					href="https://connect-pb.de/datenschutz/"
					class="footer__link"
					><p class="text__grey">Datenschutz</p></a
				>
				<a
					href="https://connect-pb.de/impressum/"
					class="footer__link"
					><p class="text__grey">Impressum</p></a
				>
			</div>
		</div>
		<div class="devider"></div>
		<div class="row__spacebetween">
			<p class="text__grey mb-30">info@connect-pb.de</p>
			<p class="text__lightgrey mb-30">
				© CONNECT - Ausbildungsmesse GmbH
			</p>
		</div>
	</div>
</template>

<script>
	import { mapActions } from "vuex";
	export default {
		name: "Footer",
		data() {
			return {};
		},
		methods: {
			...mapActions([]),
		},
		created() {},
		computed: {},
		mounted() {},
	};
</script>
<style lang="scss" scoped></style>
